import React, { useEffect, useState, useMemo } from 'react';
import { toast } from "react-toastify";
import { getData } from '../../../webService/webservice.js';
const ExpenseHeader = ({ onDataFetched, totals, currentPage, limit, searchQuery, refreshKey, dateFilters, topFilter, setTopFilter, setDateFilters }) => {
    const sessionToken = sessionStorage.getItem("Token");
    const [filter, setFilter] = useState("all");
    const [loading, setLoading] = useState(false);
    const fetchExpense = async (page = currentPage, filterValue = filter) => {
        setLoading(true);
        try {
            const params = { page, limit, filter: topFilter, search: searchQuery };
            if (topFilter === "all") {
                if (dateFilters.startDate) params.startDate = dateFilters.startDate;
                if (dateFilters.endDate) params.endDate = dateFilters.endDate;
            }
            const response = await getData("expenses/expenses", params, sessionToken);
            const resultsWrapper = response?.data?.[0];
            const ExpenseList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;
            const fetchedTotals = resultsWrapper?.totals || {};
            // send data back to parent
            onDataFetched(ExpenseList, fetchedTotals, totalCount, totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch Expenses");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchExpense();
    }, [topFilter, dateFilters.startDate, dateFilters.endDate, refreshKey, currentPage]);

    return (
        <>
            <div className='Expense-Eidgets'>
                <div className='Expense'>
                    <h3>Expenses</h3>

                    <div className="Expense-header-actions">
                        {["all", "daily", "weekly", "monthly", "yearly"].map((f) => (
                            <button
                                key={f}
                                className={`filter-btn ${topFilter === f ? "active" : ""}`}
                                onClick={() => {
                                    setTopFilter(f);

                                    // ⭐ Disable table filters for others
                                    if (f !== "all") {
                                        setDateFilters({ startDate: "", endDate: "" });
                                    }
                                }}
                            >
                                {f.charAt(0).toUpperCase() + f.slice(1)}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
            <div className="Expense-cards">
                <div className="Expense-card">
                    <div className="card-left">
                        <img src="/assets/total-expense.png" />
                    </div>
                    <div className="card-right">
                        <h3>Total</h3>
                        <p>₹{totals?.overallTotalAmount ?? 0}</p>
                    </div>
                </div>
                <div className="Expense-card">
                    <div className="card-left">
                        <img src="/assets/shop-receipt.png" />
                    </div>
                    <div className='card-right'>
                        <h3>Billable</h3>
                        <p>₹{totals?.totalBillableAmount ?? 0}</p>
                    </div>
                </div>
                <div className="Expense-card">
                    <div className="card-left">
                        <img src="/assets/non-billable.png" />
                    </div>
                    <div className='card-right'>
                        <h3>Non Billable</h3>
                        <p>₹{totals?.totalNonBillableAmount ?? 0}</p>
                    </div>
                </div>

            </div>

        </>
    );
}
export default ExpenseHeader;